export const ACTIONS = {
  SET_SUCCESS : "SET_SUCCESS",
  SET_ERROR : "SET_ERROR",
  SET_USER : "SET_USER",
  SET_JOBS : "SET_JOBS",
  SET_LOADER : "SET_LOADER"

}
